import type { ActivityViewProps } from '../../core/types/activity.types';
import { FractionModelView } from './FractionModelView';

export function FractionModelActivityView(props: ActivityViewProps<'fraction_model'>) {
  return <FractionModelView payload={props.payload} />;
}
